const getGymMembersByDate = () => {};

export default getGymMembersByDate;
